<template>
  <div class="shielding-viz">
    
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula" v-latex>$<strong>公式：</strong>E_internal = 0$</div>
    </div>

    <div class="main-layout vertical">
      <!-- 仿真区：电荷在导体表面的分布 -->
      <div class="canvas-mixed simulation">
         <svg width="100%" height="220" viewBox="0 0 400 220">
            <!-- 外部电源 (电荷源) -->
            <circle cx="50" cy="110" r="10" fill="#ff4757" />
            <text x="45" y="95" fill="#ff4757" font-size="10">+</text>
            
            <!-- 外部电场线 -->
            <g v-if="powerOn">
               <line v-for="i in 8" :key="'ef'+i" 
                 x1="65" y1="110" :x2="150" :y2="50 + i * 15" 
                 stroke="rgba(255, 71, 87, 0.2)" stroke-dasharray="4,2" marker-end="url(#arr-e)" />
            </g>

            <!-- 导体笼 (法拉第笼) -->
            <rect x="180" y="50" width="100" height="120" fill="none" stroke="#888" stroke-width="2" stroke-dasharray="2,2" />
            
            <!-- 内部检测电荷 q -->
            <circle cx="230" cy="110" r="6" :fill="qColor" />
            <text x="225" y="100" fill="#fff" font-size="9">检测 q</text>

            <!-- 笼面感应电荷 -->
            <g v-if="powerOn">
               <text x="185" y="70" fill="#00d2ff" font-size="12">-</text>
               <text x="185" y="110" fill="#00d2ff" font-size="12">-</text>
               <text x="185" y="150" fill="#00d2ff" font-size="12">-</text>
               <text x="270" y="70" fill="#ff4757" font-size="12">+</text>
               <text x="270" y="110" fill="#ff4757" font-size="12">+</text>
            </g>
         </svg>

         <div class="hud-top">
            <div class="stat">
               <label>内部场强 E_in</label>
               <span class="val">0.00 V/m</span>
            </div>
         </div>
      </div>

      <!-- 参数控制 -->
      <div class="bottom-controls">
         <div class="control-card glass">
            <div class="row center">
               <el-button :type="powerOn ? 'primary' : 'info'" size="mini" @click="powerOn = !powerOn">{{ powerOn ? '关闭外部电场' : '开启外部电场' }}</el-button>
               <el-button size="mini" @click="toggleShield">切换：{{ isShielded ? '接地屏蔽' : '绝缘状态' }}</el-button>
            </div>
         </div>

         <div class="discovery-note" v-latex>
            <p><strong>物理详解：</strong>处于电场中的导体，其内部电荷受力移动，直到内部合场强为零，达到<strong>静电平衡</strong>。利用导壳可以保护内部免受外部电场干扰，这种现象称为<strong>静电屏蔽</strong>。</p>
         </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ElectrostaticShieldingViz',
  props: { knowledgePoint: { type: String, default: '' } },
  data() {
    return {
      powerOn: true,
      isShielded: true
    }
  },
  computed: {
    qColor() {
       return this.powerOn && !this.isShielded ? '#ffd700' : '#888';
    }
  },
  methods: {
    toggleShield() {
       this.isShielded = !this.isShielded;
    }
  }
}
</script>

<style scoped lang="scss">
.shielding-viz { flex: 1; display: flex; flex-direction: column; gap: 12px; height: 100%; overflow: hidden; }
.viz-header { display: flex; justify-content: space-between; align-items: center; .title { font-size: 1rem; color: #fff; } .formula-chip { color: #00d2ff; background: rgba(0,210,255,0.1); padding: 4px 12px; border-radius: 8px; font-weight: bold; } }
.canvas-mixed { 
   background: #000; border-radius: 12px; position: relative; border: 1px solid rgba(255,255,255,0.05);
   .hud-top { position: absolute; top: 15px; right: 15px; .val { font-family: monospace; color: #2ed573; font-weight: bold; } }
}
.bottom-controls { flex: 0.5; display: flex; flex-direction: column; gap: 10px; }
.control-card { background: rgba(255,255,255,0.03); border-radius: 12px; padding: 15px; .row.center { display: flex; justify-content: center; gap: 15px; } }
.discovery-note { background: rgba(0, 210, 255, 0.05); padding: 12px 18px; border-radius: 12px; p { margin: 0; font-size: 0.75rem; color: #aaa; line-height: 1.5; strong { color: #fff; } } }
</style>
